import {
  Brawler,
  Draft,
  GuessModes,
  Team,
  TeamColors,
  arrayUnique,
} from '../common.type';

const TeamEmpty = { id: null, ban: null, starPower: null, gadget: null };

export const newDraft = (): Draft => {
  return {
    blueTeam: {
      1: { ...TeamEmpty },
      2: { ...TeamEmpty },
      3: { ...TeamEmpty },
    },
    redTeam: {
      1: { ...TeamEmpty },
      2: { ...TeamEmpty },
      3: { ...TeamEmpty },
    },
    mapId: null,
    settings: { coin: TeamColors.BLUE, mode: GuessModes.LAST, tries: 3 },
  };
};

export const checkTeam = (team: Team, brawlers: Brawler[]): boolean => {
  const values = Object.values(team);
  for (let i = 0; i < values.length; i++) {
    const idxBrawler = brawlers.findIndex((b) => b.id === values[i]?.id);
    const idxBan = brawlers.findIndex((b) => b.id === values[i]?.ban);
    if (idxBrawler === -1 || idxBan === -1) {
      return false;
    }
    const idxStarPower = brawlers[idxBrawler]?.starPowers.findIndex(
      (s) => s.id === values[i]?.starPower
    );
    const idxGadget = brawlers[idxBrawler]?.gadgets.findIndex(
      (g) => g.id === values[i]?.gadget
    );
    if (idxStarPower === -1 || idxGadget === -1) {
      return false;
    }
  }
  return true;
};

export const checkTeams = (blue: Team, red: Team): boolean => {
  const blueBrawlers = Object.values(blue).map((b) => b.id);
  const redBrawlers = Object.values(red).map((b) => b.id);
  const brawlers = arrayUnique([...blueBrawlers, ...redBrawlers]);
  return brawlers.length === 6;
};
